import script from "./BaseOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./BaseOverlay.vue?vue&type=style&index=0&id=7c62084a&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c62084a"]])

export default __exports__